import "./CustomerHeaderCard.scss";

// CustomerHeaderCard.jsx
import { Badge, Button } from "react-bootstrap";
import { faBirthdayCake, faCalendarCheck, faCopy, faPhone, faUser, faXmark } from "@fortawesome/free-solid-svg-icons";
import { formatDate, formatPhone } from "../../../../commons/util/HallAppUtil";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { useMemo } from "react";

export default function CustomerHeaderCard({ customer, onClose, onCopyPhone }) {
  const whatsappLink = useMemo(() => {
    const raw = customer?.whatsapp ? String(customer.whatsapp) : "";
    const digits = raw.replace(/\D/g, "");
    const withCountry = digits.startsWith("55") ? digits : digits ? `55${digits}` : "";
    return withCountry ? `https://wa.me/${withCountry}` : null;
  }, [customer?.whatsapp]);

  const telLink = useMemo(() => {
    const raw = customer?.whatsapp ? String(customer.whatsapp) : "";
    const digits = raw.replace(/\D/g, "");
    return digits ? `tel:${digits}` : null;
  }, [customer?.whatsapp]);

  return (
    <>
      {/* Header do modal (título + fechar) */}
      <div className="hc-cd-header__row">
        <div className="hc-cd-header__titles">
          <div className="hc-cd-header__title">Detalhes do cliente</div>
          <div className="hc-cd-header__subtitle">Informações, histórico e insights.</div>
        </div>

        <button
          type="button"
          className="btn btn-link p-0 hc-cd-header__close"
          onClick={onClose}
          aria-label="Fechar"
        >
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>

      {/* Card */}
      <div className="hc-cd-card">
        <div className="hc-cd-card__top">
          <div className="d-flex align-items-center gap-2 min-w-0">
            <div className="hc-cd-avatar" aria-hidden="true">
              <FontAwesomeIcon icon={faUser} />
            </div>

            <div className="min-w-0">
              <div className="hc-cd-name text-truncate">{customer?.name || "Cliente"}</div>

              <div className="hc-cd-meta">
                {customer?.birthday ? (
                  <span className="me-3">
                    <FontAwesomeIcon icon={faBirthdayCake} className="me-2" />
                    {customer.birthday}
                  </span>
                ) : (
                  <span className="me-3">Aniversário não informado</span>
                )}

                {customer?.lastVisit ? (
                  <span>
                    <FontAwesomeIcon icon={faCalendarCheck} className="me-2" />
                    Última visita: {formatDate(customer.lastVisit)}
                  </span>
                ) : (
                  <span>
                    <FontAwesomeIcon icon={faCalendarCheck} className="me-2" />
                    Última visita: —
                  </span>
                )}
              </div>
            </div>
          </div>

          <div className="hc-cd-actions">
            {whatsappLink && (
              <a className="btn btn-sm hc-cd-btnPrimary" href={whatsappLink} target="_blank" rel="noreferrer">
                <FontAwesomeIcon icon={faWhatsapp} className="me-2" />
                WhatsApp
              </a>
            )}

            {telLink && (
              <a className="btn btn-outline-dark btn-sm" href={telLink}>
                <FontAwesomeIcon icon={faPhone} className="me-2" />
                Ligar
              </a>
            )}

            {customer?.whatsapp && (
              <Button variant="outline-dark" size="sm" onClick={onCopyPhone}>
                <FontAwesomeIcon icon={faCopy} className="me-2" />
                Copiar
              </Button>
            )}
          </div>
        </div>

        {customer?.whatsapp ? (
          <div className="hc-cd-phone">
            <FontAwesomeIcon icon={faPhone} className="me-2" />
            {formatPhone(customer.whatsapp)}
          </div>
        ) : null}
      </div>
    </>
  );
}
